import { useCreate, useGetById, useGetList, useUpdate } from './useOrganization'

export const manage = {
  getList: useGetList,
  getById: useGetById,
  create: useCreate,
  update: useUpdate,
}
